<img
	class="module-loader-spinner"
	src="img/loading.gif"
	alt=""
/>
